<template>
    <div>
        <div v-if="loading" style="min-height: 200px; display: flex; justify-content: center; align-items: center;">
            <img src="/public/img/loading-bar.gif" />
        </div>
        <div v-else-if="resumo">
            <p v-if="!linhas.length" class="u-text-center">Nenhuma frequência lançada para este aluno.</p>
            <template v-else>
                <table class="table table-striped table-frequencia">
                    <thead>
                        <tr>
                            <th>Disciplina</th>
                            <th v-for="(nome, i) in resumo.periodos" :key="i" class="u-text-center">{{ nome }}</th>
                            <th class="u-text-center">Ano</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="linha in linhas" :key="linha.chave">
                            <td>{{ linha.nome }}</td>
                            <td v-for="(nome, i) in resumo.periodos" :key="i" class="u-text-center">
                                <template v-if="linha.dados && linha.dados.por_periodo[i + 1]">
                                    {{ linha.dados.por_periodo[i + 1].faltas }} / {{ linha.dados.por_periodo[i + 1].aulas_dadas }}
                                    <small v-if="linha.dados.por_periodo[i + 1].ac"> (A.C {{ linha.dados.por_periodo[i + 1].ac }})</small>
                                </template>
                                <template v-else>-</template>
                            </td>
                            <td class="u-text-center">{{ linha.dados ? linha.dados.faltas + ' / ' + linha.dados.aulas_dadas : '-' }}</td>
                        </tr>
                    </tbody>
                </table>
                <div class="u-mt-10">
                    <template v-if="resumo.totais.periodos_lancados.length"><b>Total do ano:</b> {{ resumo.totais.faltas_ano }} falta(s) em {{ resumo.totais.aulas_dadas_ano }} aula(s) dada(s)
                    <span v-if="resumo.totais.ac_ano"> — {{ resumo.totais.ac_ano }} aula(s) compensada(s)</span>
                    <span v-if="resumo.totais.faltas_reconsideradas"> — {{ resumo.totais.faltas_reconsideradas }} falta(s) reconsiderada(s)</span>
                    <span v-if="resumo.totais.percentual_ano !== null"
                        :style="{ color: resumo.totais.percentual_ano < resumo.frequencia_minima_percentual ? '#f56c6c' : 'inherit' }">
                        — frequência {{ resumo.totais.percentual_ano }}%
                    </span></template>
                    <i v-else>Nenhuma frequência lançada para este aluno.</i>
                </div>
            </template>
        </div>
    </div>
</template>
<script>
// Resumo da frequência por período (bimestre) de um aluno — modo diario.frequencia_modo = periodo.
export default {
    // turma_id + aluno_id (diário/fechamento) ou id da linha de frequencias (dossiê: ano letivo + contexto, sem turma).
    props: ['id', 'turma_id', 'aluno_id'],
    data: () => ({
        loading: true,
        resumo: null
    }),
    computed: {
        // Todas as disciplinas da turma (mesmo sem lançamento, com '-') + os números de cada uma.
        linhas () {
            if (!this.resumo) return [];
            const por = this.resumo.totais.por_disciplina || {};
            const base = this.resumo.disciplinas || Object.keys(por).map(chave => ({ chave, nome: por[chave].nome }));
            return base.map(l => ({ ...l, dados: por[l.chave] || null }));
        }
    },
    mounted () {
        const url = this.turma_id
            ? `${this.$store.state.config.baseUrlApi}/api/frequencia-periodo/resumoAluno/${this.aluno_id}/${this.turma_id}`
            : `${this.$store.state.config.baseUrlApi}/api/frequencia-periodo/resumoFrequencia/${this.id}`;

        this.$axios.get(url, this.$store.getters.getHeaderAuth).then(response => {
            if (response.data && response.data.erro) {
                window.eventBus.$emit('alert', { msg: response.data.erro.text || response.data.erro, type: 'warning' });
            } else {
                this.resumo = response.data;
            }
            this.loading = false;
        }).catch((error) => { this.loading = false; this.$store.commit('throwException', error); });
    }
}
</script>
